import axios, { endpoints } from "../../libs/axios";

export const fetchPages = async () => {
    try {
        const response = await axios.get(endpoints.pages.page);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch page");
        throw error;
    }
};


export const fetchBlogs = async () => {
    try {
        const response = await axios.get(endpoints.pages.blog);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch blog");
        throw error;
    }
};

